const drawerHeaderContentTokens = ({ borders, colors }) => ({
  borders: {
    top: `${borders[1]} ${colors.neutrals[5]}`,
    bottom: borders[0],
  },
  colors: colors.white,
});

export default drawerHeaderContentTokens;
